import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetStoreDetailsForOnlineOrder } from "../../api/api.get";
import { useCartContext } from "../../providers/cart.provider";
import OnlineDeliveryCheckout from "./online-order-checkout";
import OnlineDeliveryCheckoutGst from "./online-order-checkout.gst";

export default function OnlineOrderCheckoutPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: storeDetailsData, error } =
    useGetStoreDetailsForOnlineOrder(id);
  const { items, removeItem, clearCart } = useCartContext();

  const menuUrl = `/stores/${id}/online`;

  useEffect(() => {
    const _error: any = error;
    if (_error?.status === 404) {
      navigate("/not-found");
    }
  }, [error, navigate]);

  // The cart lives in memory, so a refresh or a deep link lands here empty.
  // There is nothing to check out, so send them back to the menu.
  //
  // This deliberately only runs on mount. The cart also empties once an order
  // is placed, and the GST flow keeps the customer here on a payment screen -
  // redirecting on that would throw the payment details away.
  useEffect(() => {
    if (items.length === 0) {
      navigate(menuUrl, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // IND stores are taxed per product (GST) and get their own checkout.
  const Checkout =
    storeDetailsData?.country === "IND"
      ? OnlineDeliveryCheckoutGst
      : OnlineDeliveryCheckout;

  const handleDone = () => {
    clearCart();
    navigate(menuUrl);
  };

  return (
    <div
      className="mx-auto max-w-5xl min-h-screen"
      style={{
        background: storeDetailsData?.bodyBackgroundColor ?? "white",
        color: storeDetailsData?.bodyFontColor ?? "red",
      }}
    >
      <div className="flex items-center gap-3 p-4">
        <Button
          type="text"
          aria-label="Back to menu"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(menuUrl)}
          style={{ color: "inherit" }}
        />
        <span className="text-2xl font-bold">Checkout</span>
      </div>

      <div className="px-4 pb-10">
        <Checkout
          items={items}
          storeDetails={storeDetailsData}
          onOK={handleDone}
          onOrderPlaced={clearCart}
          onRemoveItems={(item) => removeItem(item)}
        />
      </div>
    </div>
  );
}
